export const stepperSteps = ['メールの登録', 'アカウントの登録', '事業者の登録', '店舗の登録'];
